import { render, staticRenderFns } from "./UserPayment.vue?vue&type=template&id=8c2f9ada&scoped=true&"
import script from "./UserPayment.vue?vue&type=script&lang=js&"
export * from "./UserPayment.vue?vue&type=script&lang=js&"
import style0 from "./UserPayment.vue?vue&type=style&index=0&id=8c2f9ada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c2f9ada",
  null
  
)

export default component.exports